import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDecimal from "../../helpers/InputDecimal";
import InputCombo from "../../helpers/InputCombo";

import edit from "../../edit.png";
import trash from "../../trash.png";
import restore from "../../restore.png";
import gopresent from "../../gopresent.png";
import InputText from "../../helpers/InputText";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";

import TransferNew from "./TransferNew";
import TransferBank from "./TransferBank";

import CalculateEdit from "./CalculateEdit";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";

import search from "../../search.png";
import InputDate from "../../helpers/InputDate";
import AppContext from "../../AppContext";
import Xlsx from "../../exporter/Xlsx";
import TransferEdit from "./TransferEdit";


function Transfer(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


        
    const [filterParam, setFilterParam] = useState({
      
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 
        
        p_subkonta_id: props.mainView.readFilter('p_subkonta_id','_x_'),  

        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
       

        kwota_od: '',
        kwota_do: '',

        autopay: '_x_',
        usuniete: '0',

        data_od: '',
        data_do: '',

        created_at_od: '',
        created_at_do: '',


        tytul: '',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
     
        limit: 50,
        page: 1,
        pages: 1,
        show: true, 

    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku

    const [gr, setGr] = useState([]);
    const fetchGr = (fTab) => {   setGr(fTab);  }


    var defView =  {
        v:'list',
        id: -1
    } ;

    if(props.mainView.idSelected == -20) //wplata recnza
    {
        defView =  {
            v:'new',
            id: -1
        } ;
    }

    if(props.mainView.idSelected == -30) //wplata bank
    {
        defView =  {
            v:'bank',
            id: -1
        } ;
    }


    const [view, setView] = useState ( defView);


    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'pozycja usunięta',
            filter: {  filed: "usuniete", set: "1", typ: "combo"  },
        },
        {
            cls:'color_show4',
            title: 'płatność OnLine',
            filter: {  filed: "autopay", set: "2", typ: "combo"  }, //tylko przelewy online
        },
    ]);


       
    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
}

    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }



   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_calc,transfer', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  

                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.numer_umowy + " ("+item.imie + " " + item.nazwisko +")",
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {

       
        props.mainView.writeFilter('p_group_id', '_x_'); 

        props.mainView.writeFilter('d_imie_nazwisko', ''); 
        props.mainView.writeFilter('r_imie_nazwisko', ''); 
 
   

        setFilterParam({
            d_imie_nazwisko: '', 
            r_imie_nazwisko: '', 
                        
            p_grupa_id: '_x_',        
            
      
            
            kwota_od: '',
            kwota_do: '',

            data_od: '',
            data_do: '',

            created_at_od: '',
            created_at_do: '',
            

            p_subkonta_id: '_x_',    
            
            autopay: '_x_',
            usuniete: '0',

            tytul: '',            

         
            
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },

            limit: 50,
            page: 1,
            show: true, 
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }



    const searchParent = (e) => {

        var search = e.target.getAttribute("search");
        //alert(search);

        setFilterParam( {...filterParam, ["r_imie_nazwisko"]:search,  ["r_imie_nazwisko_valid"]:true } );
        setTab(null);
    }

    const searchKid = (e) => {

        var search = e.target.getAttribute("search");
        //alert(search);

        setFilterParam( {...filterParam, ["d_imie_nazwisko"]:search,  ["d_imie_nazwisko_valid"]:true } );
        setTab(null);
    }





    const reviewKid = (e) =>
        {
            var id        = e.target.getAttribute("id");
            var imie      = e.target.getAttribute("imie");
            var nazwisko  = e.target.getAttribute("nazwisko");
    
            props.mainView.openKid( id, imie, nazwisko );
        }

        




    if(tab == null)
    {
        setTab([]);
        getTab();
    

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }



    const changeSelected = (e) => {

        var id    = e.target.getAttribute('atr-id');   
        var selected = 0;
    
        if(e.target.checked) selected = 1;
    
        for(var k=0; k<selectedRow.length; k++)
        {
            if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
    }
    
    const changeSelectedAll = (e) => {
    
        var s = selectedRow[0].selected;
        if(s == 1) {  s = 0; } else s = 1;
    
        for(var k=0; k<selectedRow.length; k++)
            {
              selectedRow[k].selected = s;
            }
        
            setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 
    
    }


    const goDelete = (e) => {


        var id = e.target.getAttribute('atr-id');
        var title = e.target.getAttribute('atr-title');
        var ids = new Array();
    
    
        ids.push({
            id: id,
            title: title,
        });
    
    
        var tt = title;
        if(tt.length > 30) tt = tt.substring(0, 30)+"...";
    

      

    
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć: \"" + tt + "\" ?", "yesno", (option)=>{
                      
            ///--------
            if(option == "yes")
            {
                        props.mainView.setProgress(-2);
    
                        var req = {
                            ids: ids,                            
                        }
    
                        fetch( Config.url + '/rest_v1_calc,transfer_del', {
                            method: 'POST', 
                            body: JSON.stringify(req), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => { 
    
                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {      
                                        props.mainView.showDialog( "Sukces", "Usuniętych pozycji: " + res.result , "ok" , null);                               
                                        getTab();            
                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });
            }//koniec yes
            //--------
        } );
    
    }

    

    const goDeleteMass = (e) => {


        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej pozycji' ,  "ok"  ,null); 
            return;              
         }
    
                
    
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybrane pozycje (" + ids.length + ")?", "yesno", (option)=>{
                      
            ///--------
            if(option == "yes")
            {
                        props.mainView.setProgress(-2);
    
                        var req = {
                            ids: ids,                            
                        }
    
                        fetch( Config.url + '/rest_v1_calc,transfer_del', {
                            method: 'POST', 
                            body: JSON.stringify(req), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => { 
    
                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {      
                                        props.mainView.showDialog( "Sukces", "Usuniętych pozycji: " + res.result , "ok" , null);                               
                                        getTab();            
                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });
            }//koniec yes
            //--------
        } );
    
    }


    const goRestore = (e) => {


        var id = e.target.getAttribute('atr-id');
        var title = e.target.getAttribute('atr-title');
        var ids = new Array();
    
    
        ids.push({
            id: id,
            title: title,
        });
    
    
        var tt = title;
        if(tt.length > 30) tt = tt.substring(0, 30)+"...";
    
    
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz przywrócić pozycje: \"" + tt + "\" ?", "yesno", (option)=>{
                      
            ///--------
            if(option == "yes")
            {
                        props.mainView.setProgress(-2);
    
                        var req = {
                            ids: ids,                            
                        }
    
                        fetch( Config.url + '/rest_v1_calc,transfer_restore', {
                            method: 'POST', 
                            body: JSON.stringify(req), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => { 
    
                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {      
                                        props.mainView.showDialog( "Sukces", "Przywróconych pozycji: " + res.result , "ok" , null);                               
                                        getTab();            
                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });
            }//koniec yes
            //--------
        } );
    
    }

    

    const goRestoreMass = (e) => {


        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej pozycji' ,  "ok"  ,null); 
            return;              
         }
    
                
    
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz przywrócić wybrane pozycje (" + ids.length + ")?", "yesno", (option)=>{
                      
            ///--------
            if(option == "yes")
            {
                        props.mainView.setProgress(-2);
    
                        var req = {
                            ids: ids,                            
                        }
    
                        fetch( Config.url + '/rest_v1_calc,transfer_restore', {
                            method: 'POST', 
                            body: JSON.stringify(req), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => { 
    
                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {      
                                        props.mainView.showDialog( "Sukces", "Przywróconych pozycji: " + res.result , "ok" , null);                               
                                        getTab();            
                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });
            }//koniec yes
            //--------
        } );
    
    }



    const onSuccess = () => {
        getTab();
    }

    const goBack = () => {

        setView({
            v: "list", id: -1
        })

        getTab();
    }




    


    const itemsAt = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie, ukryj' },               
        { v: '2', title: 'Tylko przelewy onLine' },         
    ]; 


    const itemsTakNie = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie' },               
        { v: '1', title: 'Tak' },         
    ]; 





    var sortList = [                
        {column: "kwota", name: "Kwota"  },
        {column: "kwota_rozliczenia", name: "Kwota rozliczenia"  },
        {column: "data", name: "Data"  },
        {column: "tytul", name: "Tytuł"  },

        {column: "dziecko_nazwisko", name: "Dziecko"  },
        {column: "rodzic_nazwisko", name: "Rodzic"  },
]


    
    var zaznaczonych = 0;
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) zaznaczonych ++;
    }


    var razemKwota = 0;
    var razemRozliczono = 0;
    var razemPozostalo = 0;


   var razemKwota2 = 0;
    var razemRozliczono2 = 0;
    var razemPozostalo2 = 0;


    
    if(view.v == 'new')
        {
            return <TransferNew   userData={props.userData}  mainView={props.mainView}  goBack={goBack} onSuccess={onSuccess}  />
        }

        if(view.v == 'bank')
            {
                return <TransferBank   userData={props.userData}  mainView={props.mainView}  goBack={goBack} onSuccess={onSuccess}  />
            }        


     if(view.v == 'roz' && view.id > 0)
                {       
                     var rowx = [{empty:true}];

                    for(var k=0; k<tab.length; k++)
                    {
                        if(tab[k].id == view.id) rowx = tab[k];
                         
                    }

                    return <CalculateEdit    userData={props.userData}  mainView={props.mainView}   goBack={goBack} onSuccess={onSuccess}    p_saldo_ma_wn_id={view.id} />
                } 

    if(view.v == 'edit' && view.id > 0)
                {          
                   
                    var rowx = [{empty:true}];

                    for(var k=0; k<tab.length; k++)
                    {
                        if(tab[k].id == view.id) rowx = tab[k];
                         
                    }
               

                    return <TransferEdit    userData={props.userData}  mainView={props.mainView}   id={view.id} goBack={goBack} onSuccess={onSuccess}   row={rowx} />
                } 


    var titleRaport = "Przelewy i wpłaty "; 

    if(filterParam.p_grupa_id != '_x_') 
    {
        for(var p=0; p < gr.length; p++)
        {
            if(gr[p].v == filterParam.p_grupa_id)
            {
                titleRaport += " " + gr[p].title;
                break;
            }
        }
    }else  titleRaport += " wszystkie grupy" ;

    if(filterParam.d_imie_nazwisko.length > 1)
    {
        titleRaport += ", dziecko: " + filterParam.d_imie_nazwisko;
    }

    if(filterParam.r_imie_nazwisko.length > 1)
    {
        titleRaport += ", rodzic: " + filterParam.r_imie_nazwisko;
    }

if(filterParam.data_od.length > 1)
    {
        titleRaport += ", od dnia: " + filterParam.data_od;
    }
    
if(filterParam.data_do.length > 1)
    {
        titleRaport += ", do dnia: " + filterParam.data_do;
    }    

  
    document.title = titleRaport;





    return <div className="view_content">
          

            {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
            } 


            {
                    filterParam.show == true  &&
                                    <div className="table_filter">

                                    <div className="filter_controll">   
                                        <label>Grupa: </label>                             
                                        <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}  fetchTab={fetchGr}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                                    </div> 


                                                
                                    <div className="filter_controll">   
                                                <label>Dziecko: </label>                             
                                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                                    </div>  

                                    <div className="filter_controll">   
                                                <label>Rodzic: </label>                             
                                                <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                                    </div> 



                
                                    <div className="filter_controll">   
                                                <label>Tytuł (fraza): </label>                             
                                                <InputText   userData={props.userData} value={filterParam.tytul}   valChange={valChangeListener} goNext={goNextNew} name="tytul" placeholder={"Imię: "}   />
                                    </div> 


                                    <div className="filter_controll">   
                                        <label>Subkonto: </label>                             
                                        <InputComboSubkonto userData={props.userData}  mainView={props.mainView}  value={filterParam.p_subkonta_id}   valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={" "}   />
                                    </div> 


                                    <div className="filter_controll filter_merge">   
                                        <label>Kwota (od / do): </label>        
                                        <br/>                     
                                        <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_od" placeholder={" "}   />
                                        <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_do" placeholder={" "}   />
                                    </div> 


                                    <div className="filter_controll">   
                                    <label>Przelew onLine: </label>                             
                                    <InputCombo  items={itemsAt}  userData={props.userData}  mainView={props.mainView}  value={filterParam.autopay}   valChange={valChangeListener} goNext={goNextNew} name="autopay" placeholder={" "}   />
                                </div> 

                                <div className="filter_controll">   
                                    <label>Usunięte: </label>                             
                                    <InputCombo  items={itemsTakNie}  userData={props.userData}  mainView={props.mainView}  value={filterParam.usuniete}   valChange={valChangeListener} goNext={goNextNew} name="usuniete" placeholder={" "}   />
                                </div> 




                                <div className="filter_controll filter_merge">   
                                    <label>Data (od dnia / do dnia): </label>      <br/>                       
                                    <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                    <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                                </div>


                            <div className="filter_controll filter_merge">   
                                    <label>Data systemowa (od dnia / do dnia): </label>      <br/>                       
                                    <InputDate   userData={props.userData} value={filterParam.created_at_od}   valChange={valChangeListener} goNext={goNextNew} name="created_at_od" placeholder={"Od dnia: "}   />                                                                  
                                    <InputDate   userData={props.userData} value={filterParam.created_at_do}   valChange={valChangeListener} goNext={goNextNew} name="created_at_do" placeholder={"Do dnia: "}   />
                                </div>


                                    <div className="filter_btn">
                                        <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                        <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                    </div>
                </div>
            } 

          


            <div className="bg_center">


                    <div className="table_widget">
                          
            
                           <div className="btn" onClick={changeView} v="new" id="-1"  > Dodaj wpłatę / zwrot</div>
                     
                           &nbsp; &nbsp;

                           <div className="btn" onClick={changeView} v="bank" id="-1"  > Importuj z banku</div>

                               

                           <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                           <InputLegend items={legend}  valChange={valChangeListener}/>

                            &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref} title={titleRaport + ".csv"} />                  
                                    <Xlsx tabRef={tab2Ref} title={titleRaport + ".xlsx" } />                  
                                    <Print tabRef={tab2Ref}  title={titleRaport  }  />

                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />        

                    </div>


                    <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>                    
                                    &nbsp;
                                    <span className="btn" onClick={goDeleteMass}  >Usuń</span>       
                                    &nbsp;
                                    <span className="btn" onClick={goRestoreMass} >Przywróć</span>                             
                    </div>


                    <div className="gohide" ref={tabRef}>

                                <h3>{titleRaport}</h3>   

                                <table className="table" ref={tab2Ref}>
                                        <thead>
                                            <tr className="header">                                                                                        
                                                <td>LP</td>                                                                                                                             
                                                <td>Rodzic</td>                                                                                  
                                                <td>Dziecko</td>                                                                                  
                                                <td>Subkonto</td>                                                                                  
                                                <td>Kwota wpłacona</td>                                                                                                                                                                                                             
                                                <td>Data</td>                                                                                                                                
                                                <td>Tytuł</td>                                                                                                                                                                   
                                                <td>Rodzaj</td>                                                                                          
                                                <td>Kwota rozliczona</td>                                                                                                                            
                                            </tr>
                                        </thead>
                                        <tbody>

                                        {
                                                tab.map(  (row, ix) => { 

                                                        razemKwota2      = parseFloat(razemKwota2) + parseFloat(row.kwota);
                                                        razemRozliczono2 = parseFloat(razemRozliczono2) + parseFloat(row.kwota_rozliczenia);
                                                        razemPozostalo2 = parseFloat(razemPozostalo2) + parseFloat(row.pozostalo);

                                                        return <tr>                                                                                                 
                                                        <td>{ix + 1}</td>                                                                                                                             
                                                        <td>
                                                            {row.rodzic.nazwisko + " " + row.rodzic.imie}                                                           
                                                        </td>   
                                                        <td>
                                                            {row.dziecko.nazwisko + " " + row.dziecko.imie  }                                                             
                                                        </td> 
                                                        <td>{row.subkonto.nazwa}</td>                                                                                  
                                                        <td className="goright">  <FormatDecimal value={row.kwota}/></td>                                                                                                                                                                                                                      
                                                        <td className="goright">{row.data}</td>                                                                                                                                                                                                     
                                                        <td>{row.tytul}</td>                                                                                                                                                                                                               
                                                        <td className="gocenter">{row.typ_wplaty} </td>                                                                                                                                  
                                                        <td className="goright"><FormatDecimal value={row.kwota_rozliczenia}/></td>                                                         
                                                    </tr>

                                                })
                                        }

                                           <tr className={ "row "  }>
                                            
                                                        <td className="gocenter">  &nbsp; </td>                                                                                                                             

                                                        <td>  &nbsp; </td>                                                                                  
                                                        <td>  &nbsp; </td>                                                                                  
                                                        <td>  &nbsp; </td>                                                                                  

                                                        <td className={"goright gobold" } title="Razem"> <FormatDecimal value={razemKwota2}/></td> 

                                                        <td className="gocenter">&nbsp;</td>                                                                                  
                                                        <td className="gocenter"> &nbsp; </td> 

                                                        <td> &nbsp; </td>                                                                                                                                                                                                                                                             
                                                        <td className="goright gobold"><FormatDecimal value={razemRozliczono2}/> </td>
                          

                                                    </tr>

                                        </tbody>
                    </table>
                    </div>

                <div className="scorll_x">
                    <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>                                                
                                                <td>LP</td>                                                                                      
                                                <td>Dziecko</td>                                             
                                                <td>Rodzic</td>                                                                                                                                                                                                            
                                                <td>Subkonto</td>                                                                                  
                                                <td>Kwota wpłacona</td>                                                                                                                                                                                                             
                                                <td>Data</td>                                                                                  
                                                <td>Data sys.</td>                                                                                  
                                                <td>Tytuł</td>                                                                                                                                                                   
                                                <td>Rodzaj</td>                                                                                          
                                                <td>Kwota roz.</td>                                                                                          
                                                <td className="td_right">Pozostało do wyk.</td>                                           
                                                <td className="td_option">                                                                   
                                                </td>                                           
                                            </tr>
                                        </thead>
                                        <tbody>

                                        {
                                                tab.map(  (row, ix) => {

                                                        var isChecked = "";

                                                        for(var s=0; s<selectedRow.length; s++)
                                                        {
                                                            if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                        }


                                                        var typCSS = "amount_plus";
                                                        var rozCSS = "amount_minus";
                                                        var titleX = "Uznanie - idź do rozliczeń"


                                                        if(row.typ == "wn") 
                                                        {
                                                            typCSS = "amount_minus";
                                                            titleX = "Obciążenie - idź do rozliczeń" ;
                                                        }

                                                        if(row.kwota === row.kwota_rozliczenia)
                                                        {
                                                            rozCSS =  "amount_plus";
                                                        }
                                                     

                                                        var css = " ";
                                                        if( row.autopay != null &&  row.autopay.id > 0) css = 'color_show4';
                                                        if(row.is_delete == '1') css = 'color_deleted';


                                                        razemKwota      = parseFloat(razemKwota) + parseFloat(row.kwota);
                                                        razemRozliczono = parseFloat(razemRozliczono) + parseFloat(row.kwota_rozliczenia);
                                                        razemPozostalo = parseFloat(razemPozostalo) + parseFloat(row.pozostalo);


                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                                        return <tr className={ rowStyle + css } key={ix}>
                                                        <td className="gocenter"> <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} /> </td>                                                
                                                        <td className="gocenter">{ix + 1}</td>                                                 
                                                        <td>
                                                            {row.dziecko.nazwisko + " " + row.dziecko.imie }
                                                            <img src={gopresent} id={row.dziecko.id} imie={row.dziecko.imie} nazwisko={row.dziecko.nazwisko} onClick={reviewKid} title="podgląd"  />  
                                                            <img src={search} className="small_tip_img" title="Pokaż tylko to dziecko"  search={row.dziecko.nazwisko + " " + row.dziecko.imie} onClick={searchKid} /> 
                                                        </td>                                                                              
                                                        <td>
                                                            {row.rodzic.nazwisko + " " + row.rodzic.imie}
                                                            <img src={search} className="small_tip_img" title="Pokaż tylko tego rodzica"  search={row.rodzic.nazwisko + " " + row.rodzic.imie} onClick={searchParent} />
                                                        </td>                                                                                                                                          
                                                        <td>{row.subkonto.nazwa}</td>                                                                                  
                                                        <td className={"goright link_normal " + typCSS} title={titleX}   onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id}  >  <FormatDecimal value={row.kwota}/></td>                                                                                                                                                                                                                      
                                                        <td className="gocenter link_normal"  title={titleX}   onClick={changeView} v="edit" id={row.id} >{row.data}</td>                                                                                  
                                                        <td className="gocenter">{row.created_at}</td>                                                                                  
                                                        <td  className="link_normal"  title={titleX}   onClick={changeView} v="edit" id={row.id} >{row.tytul}</td>                                                                                                                                                                                                               
                                                        <td>{row.typ_wplaty} </td>                                                                                                                                  
                                                        <td className={"goright link_normal  " + rozCSS } title="Idź do rozliczeń" onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id}  ><FormatDecimal value={row.kwota_rozliczenia}/></td>  
                                                        <td className={"goright link_normal  " + rozCSS } title="Idź do rozliczeń" onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id}  ><FormatDecimal value={row.pozostalo}/></td>  

                                                        <MenuTable>
                                                            <ul>

                                                                    {
                                                                        row.is_delete == '0' &&
                                                                        <Fragment>
                                                                            
                                                                            <li atr-id={row.id} atr-title={row.tytul}  onClick={goDelete} >usuń</li>

                                                                            <li title={titleX}   onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id}  >rozliczenia</li>

                                                                            <li title={titleX}   onClick={changeView} v="edit" id={row.id}  >edytuj</li>
                                                                        </Fragment>
                                                                    } 

{
                                                                        row.is_delete == '1' &&
                                                                        <Fragment>
                                                                            <li atr-id={row.id} atr-title={row.tytul}  onClick={goRestore} >przywróć</li>
                                                                        </Fragment>
                                                                    } 

                                                            </ul>
                                                        </MenuTable>

                                                       
                                                    </tr>

                                                })
                                        }

                                                   <tr className={ "row "  }>

                                                        <td className="gocenter">  &nbsp; </td>                                                
                                                        <td className="gocenter">  &nbsp; </td>                                                                                                                             

                                                        <td>  &nbsp; </td>                                                                                  
                                                        <td>  &nbsp; </td>                                                                                  
                                                        <td>  &nbsp; </td>                                                                                  

                                                        <td className={"goright gobold" } title="Razem"> <FormatDecimal value={razemKwota}/></td> 

                                                        <td className="gocenter">&nbsp;</td>                                                                                  
                                                        <td className="gocenter"> &nbsp; </td> 

                                                        <td> &nbsp; </td>                                                                                                                                                                                                     
                                                        <td> &nbsp;  </td>
                                                        <td className="goright gobold"><FormatDecimal value={razemRozliczono}/> </td>

                                                        <td className={"goright gobold "  }><FormatDecimal value={razemPozostalo}/></td>  
                                                     

                                                    </tr>

                                        </tbody>
                    </table>
                </div>

            </div>


    </div>
}


export default Transfer;